<div [ngClass]="level >0 ? '' :isSelf? 'selfMargin': 'otherMargin'">
  <div class="p-2"> <!-- header -->
    <div *ngIf="!isSelf">
      <div class="d-flex">
        <div class="d-flex  justify-content-center align-items-center">
          <sb-avatar [users]="[post?.createdBy]"></sb-avatar>
        </div>
        <div class="ml-2">
          <p [innerHTML]="post?.createdBy?.name |truncate: 35" class="font-weight-bold m-1"></p>
          <!-- [innerHTML]=element.name | truncate : 23"></p>-->
          <small class="m-1">
            <sb-icon icon="plus"></sb-icon>&nbsp;
            <span [innerHTML]="passedTime(post?.createdAt, 'day')" container="body"
                  [ngbTooltip]="post?.createdAt?.toString() | date: 'dd.MM.yy HH:mm'"></span>
          </small>
          <small *ngIf="post?.modifiedAt" class="m-1">
            <sb-icon icon="edit"></sb-icon>&nbsp;
            <span [innerHTML]="passedTime(post?.modifiedAt, 'day')" container="body"
                  [ngbTooltip]="post?.modifiedAt?.toString() | date: 'dd.MM.yy HH:mm'"></span>
          </small>
        </div>
      </div>
    </div>
    <div *ngIf="isSelf" class="d-flex justify-content-end pt-2">
      <div>
        <p [innerHTML]="post?.createdBy?.name |truncate: 35" class="font-weight-bold m-1"></p>
        <!-- [innerHTML]=element.name | truncate : 23"></p>-->
        <small class="m-1">
          <sb-icon icon="plus"></sb-icon>&nbsp;
          <span [innerHTML]="passedTime(post?.createdAt, 'day')" container="body"
                [ngbTooltip]="post?.createdAt?.toString() | date: 'dd.MM.yy HH:mm'"></span>
        </small>
        <small *ngIf="post?.modifiedAt" class="m-1">
          <sb-icon icon="edit"></sb-icon>&nbsp;
          <span [innerHTML]="passedTime(post?.modifiedAt, 'day')" container="body"
                [ngbTooltip]="post?.modifiedAt?.toString() | date: 'dd.MM.yy HH:mm'"></span>
        </small>
      </div>
      <div class=" d-flex justify-content-center align-items-center">
        <sb-avatar *ngIf="isSelf" [users]="[post?.createdBy]"></sb-avatar>
      </div>
    </div>

  </div>
  <div [ngStyle]="{'background-color': checkLevel(level, isSelf), 'border': isSolution? '3px solid #ffb822' : ''}"
       class="p-3 chatBox">
    <!-- body -->
    <div class="row">
      <div class="col-11">
        <div (click)="!solutionDisplay?replyClick($event):''" *ngIf="!editClicked">
          <ng-container *ngIf="!post?.deletedAt">{{post?.text}}</ng-container>
          <i *ngIf="post?.deletedAt">{{post?.text}}</i>
          <p *ngIf="post?.deletedAt">
            <small [innerHTML]="passedTime(post?.deletedAt, 'day')" container="body"
                   [ngbTooltip]="post?.deletedAt?.toString() | date: 'dd.MM.yy HH:mm'"></small>
          </p>
        </div>
      </div>
      <div *ngIf="!solutionDisplay" class="col-1 align-items-center">
        <!-- Check if user is allowed to mark as solution-->
        <sb-icon class="solution-star" [ngClass]="isSolution ? 'btn-solution-true' : 'grey'"
                 *ngIf="(isSolutionClickable || isSolution)&& topic?.createdBy?.name === currentUser?.name && !post?.deletedAt"
                 icon="starFilled" (click)="markSolution($event)"></sb-icon>
        <!-- user not allowed to mark solution-->

      </div>
    </div>
    <div *ngIf="editClicked">
      <label class="form-label d-flex justify-content-end" for="Edit"></label>
      <textarea [(ngModel)]="reply" class="form-control chatBox" id="Edit" name="EditField" rows="4"
                sbAutofocus
                type="text"></textarea>
    </div>
    <div *ngIf="post?.mentions?.length>0" class="d-flex mt-2 align-items-center">
      {{'lang.discussion.mentioned'|translate}}
      <div *ngFor="let user of post.mentions" class="ml-1">
        <div *ngIf="post.mentions.length <= 3" class="d-flex align-items-center">
          <sb-avatar [users]="[user]"></sb-avatar>
          <span class="font-weight-bold mx-2">
                   {{user.firstname}} {{user.lastname}}
                </span>
        </div>
        <div *ngIf="post.mentions.length > 3">
          <sb-avatar [users]="[user]" [ngbTooltip]="user.firstname + ' ' + user.lastname"></sb-avatar>
        </div>
      </div>
    </div>
    <div *ngIf="isSelf && !post?.deletedAt && !solutionDisplay">
      <hr>
      <div class="d-flex justify-content-end my-2">
        <sb-icon (click)="editComment($event)" class="cursor-pointer mr-2" icon="edit"></sb-icon>
        <sb-icon (click)="deleteComment($event)" class="cursor-pointer ml-2" icon="trash"></sb-icon>
      </div>
    </div>
    <ng-content>
    </ng-content>
    <!--Reply part starts here -->
    <div *ngIf="replyClicked && !solutionDisplay" class="pt-2">
      <label class="form-label d-flex justify-content-end" for="Reply">
        <div class="mr-2">
          <p [innerHTML]="currentUser.name| truncate: 35" class="font-weight-bold m-1"></p>
          <!-- [innerHTML]=element.name | truncate : 23"></p>-->
          <p [innerHTML]="getCurrentTime()?.toString()| date: 'dd.MM.yy HH:mm'" class="m-1"></p>
        </div>
        <div>
          <sb-avatar [users]="[currentUser]"></sb-avatar>
        </div>
      </label>
      <div *ngIf="replyClicked">
        <div>
        <textarea [(ngModel)]="reply"
                  [placeholder]="reply===''?('lang.discussion.addReply'| translate):reply" class="form-control chatBox"
                  id="Reply" name="ReplyField"
                  rows="4" sbAutofocus
                  type="text"></textarea>
        </div>
        <div class="d-flex justify-content-end mt-2">
          <button (click)="sendReply($event)"
                  class="btn btn-hover-primary mr-2">{{'lang.globals.reply' | translate}}</button>
          <button (click)="replyClick($event)" class="btn btn-danger">{{'lang.globals.close' | translate}}</button>
        </div>
      </div>
    </div>
  </div>
</div>
